import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as CorrespondenceRequestCategoryActions from './request-category.actions';
import { CorrespondenceRequestCategoryService } from '../../services/request-category.service';

@Injectable()
export class CorrespondenceRequestCategoryEffects {
  loadCorrespondenceRequestCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        CorrespondenceRequestCategoryActions.loadCorrespondenceRequestCategory
      ),
      exhaustMap((_) =>
        this.correspondenceRequestCategoryService
          .getCorrespondenceRequestCategory()
          .pipe(
            map((data) =>
              CorrespondenceRequestCategoryActions.loadCorrespondenceRequestCategorySuccess(
                { correspondenceRequestCategory: data }
              )
            ),
            catchError((error) =>
              of(
                CorrespondenceRequestCategoryActions.loadCorrespondenceRequestCategoryFailure(
                  { error }
                )
              )
            )
          )
      )
    )
  );

  addCorrespondenceRequestCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        CorrespondenceRequestCategoryActions.addCorrespondenceRequestCategory
      ),
      concatMap(({ newCorrespondenceRequestCategory }) =>
        this.correspondenceRequestCategoryService
          .createCorrespondenceRequestCategory(newCorrespondenceRequestCategory)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return CorrespondenceRequestCategoryActions.addCorrespondenceRequestCategorySuccess(
                {
                  newCorrespondenceRequestCategory: data,
                }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceRequestCategoryActions.addCorrespondenceRequestCategoryFailure(
                  { error: error.error.message }
                )
              )
            )
          )
      )
    )
  );

  updateCorrespondenceRequestCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        CorrespondenceRequestCategoryActions.updateCorrespondenceRequestCategory
      ),
      map((action) => action.updateCorrespondenceRequestCategory),
      concatMap((updateCorrespondenceRequestCategory) =>
        this.correspondenceRequestCategoryService
          .updateCorrespondenceRequestCategory(
            updateCorrespondenceRequestCategory
          )
          .pipe(
            map((_) => {
              this.notification.success('Updated Successfully');
              return CorrespondenceRequestCategoryActions.updateCorrespondenceRequestCategorySuccess(
                {
                  updateCorrespondenceRequestCategory: updateCorrespondenceRequestCategory,
                }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceRequestCategoryActions.updateCorrespondenceRequestCategoryFailure(
                  { error: error.message }
                )
              )
            )
          )
      )
    )
  );

  removeCorrespondenceRequestCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        CorrespondenceRequestCategoryActions.removeCorrespondenceRequestCategory
      ),
      map((action) => action.ids),
      concatMap((ids) =>
        this.correspondenceRequestCategoryService
          .deleteCorrespondenceRequestCategory(ids)
          .pipe(
            map(() => {
              this.notification.success('Deleted Successfully');
              return CorrespondenceRequestCategoryActions.removeCorrespondenceRequestCategorySuccess(
                { ids }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceRequestCategoryActions.updateCorrespondenceRequestCategoryFailure(
                  { error: error.message }
                )
              )
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private correspondenceRequestCategoryService: CorrespondenceRequestCategoryService,
    private notification: NotificationService
  ) {}
}
